import React from 'react';
import { Save } from 'lucide-react';

/**
 * Sticky "unsaved changes" bar. Renders whenever the barber has
 * touched hours / breaks / exceptions / policy dropdowns and hasn't
 * saved yet. Impossible to miss on the way to another page.
 */
export const DirtyBar = ({ barberName, saving, onDiscard, onSave }) => (
  <div className="sched-dirty-bar" data-testid="sched-dirty-bar" role="status" aria-live="polite">
    <div className="sched-dirty-inner">
      <div className="sched-dirty-msg">
        <span className="dot" aria-hidden="true" />
        You have unsaved changes to {barberName}&rsquo;s schedule.
      </div>
      <div className="sched-dirty-actions">
        <button
          type="button"
          className="btn s"
          onClick={onDiscard}
          disabled={saving}
          data-testid="sched-discard"
        >Discard</button>
        <button
          type="button"
          className="btn p"
          onClick={onSave}
          disabled={saving}
          data-testid="sched-save-sticky"
        >
          <Save size={14} /> {saving ? 'Saving…' : 'Save changes'}
        </button>
      </div>
    </div>
  </div>
);
